import { DeviceFingerprint } from "@emed-labs/ftf-datatypes/lib/SessionData/DeviceFingerprint";
import { BrowserUtils } from "./BrowserUtils";
import { ObjectUtils } from "@emed-labs/platform-utility-common-utils";
import { LoggerContext } from "@emed-labs/platform-utility-logger-context";
import { UAParser } from "ua-parser-js";

const LOGGER = LoggerContext.create("utils.DeviceFingerprintUtils");

export class DeviceFingerprintUtils {
	static async getDeviceFingerprint(): Promise<Partial<DeviceFingerprint>> {
		if (!BrowserUtils.isBrowser()) {
			throw new Error("Device fingerprinting must be done in a browser context");
		}
		try {
			// Parse the user agent string
			const parser = new UAParser();
			const result = parser.getResult();

			// Map UAParser result to your fingerprint format
			const deviceFingerprint: Partial<DeviceFingerprint> = ObjectUtils.deepRemoveEmpty({
				browserName: result.browser.name,
				browserVersion: result.browser.version,
				browserUserAgent: window?.navigator?.userAgent ?? "-",
				osName: result.os.name,
				osVersion: result.os.version,
				deviceType: result.device.type ?? (result.device.type === undefined ? "-" : undefined),
				deviceName: result.device.model,
				deviceBrand: result.device.vendor
			});

			LOGGER.info("getDeviceFingerprint", "Detected Device Fingerprint", deviceFingerprint);
			return deviceFingerprint;
		} catch (err) {
			LOGGER.error("getDeviceFingerprint", "Failed to parse device fingerprint", err);
			// Optionally return minimal fallback data
			return {
				browserName: "-",
				browserVersion: "-",
				osName: "-",
				osVersion: "-",
				browserUserAgent: window?.navigator?.userAgent ?? "-",
				deviceType: "-",
				deviceName: "-",
				deviceBrand: "-"
			};
		}
	}
}
